import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Clock, Award, Heart } from 'lucide-react';
const features = [{
  icon: Award,
  title: '专业认证',
  subtitle: 'Certified Professionals',
  desc: '所有技师均持有专业资格证书，经过严格筛选与系统培训，精通多种按摩手法，确保为您提供最专业的新加坡按摩服务。'
}, {
  icon: Shield,
  title: '隐私保护',
  subtitle: 'Privacy Guaranteed',
  desc: '严格的保密制度与隐私保护措施，全程保障每位客户的个人信息安全，让您在新加坡安心享受高端按摩与伴游服务。'
}, {
  icon: Clock,
  title: '24小时服务',
  subtitle: '24/7 Available',
  desc: '全天24小时不间断预约服务，支持上门按摩与酒店按摩，无论何时何地，幸福缘随时为您提供最便捷的新加坡按摩服务。'
}, {
  icon: Heart,
  title: '五星体验',
  subtitle: '5-Star Experience',
  desc: '超过2000+满意客户的真实好评与推荐，新加坡幸福缘致力于为每一位客户提供五星级的极致放松与身心愉悦体验。'
}];
export function WhyChooseUs() {
  return <section id="why-us" className="py-24 bg-[#1a1a2e] text-white relative overflow-hidden" data-id="element-206">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-207">
        <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-[#c9a96e] blur-3xl" data-id="element-208" />
        <div className="absolute -bottom-24 -left-24 w-96 h-96 rounded-full bg-[#8b2252] blur-3xl" data-id="element-209" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-210">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-211">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-212">
            <h2 className="text-4xl md:text-5xl font-serif font-bold mb-6 leading-tight" data-id="element-213">
              为何选择
              <br data-id="element-214" />
              <span className="text-[#c9a96e]" data-id="element-215">幸福缘</span> ?
            </h2>
            <p className="text-xl text-gray-300 mb-8 font-light" data-id="element-216">
              Why Choose Happiness Connection?
            </p>
            <div className="space-y-4 text-gray-400 leading-relaxed mb-8 text-lg" data-id="element-217">
              <p data-id="element-218">
                我们致力于为您提供新加坡最高端的按摩与伴游服务。在这里，每一次体验都是一场身心的洗礼，每一刻时光都值得被珍藏。
              </p>
              <p data-id="element-219">
                作为新加坡领先的专业按摩服务平台，幸福缘始终坚持以客户为中心，严格把控服务品质。我们的技师团队均经过专业培训与严格考核，精通精油按摩、泰式按摩、深层组织按摩等多种手法，确保每一位客户都能享受到最专业、最贴心的服务体验。
              </p>
            </div>
            <div className="w-20 h-1 bg-[#c9a96e]" data-id="element-220" />
          </motion.div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8" data-id="element-221">
            {features.map((feature, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="bg-white/5 backdrop-blur-sm p-6 rounded-sm border border-white/10 hover:bg-white/10 transition-colors duration-300" data-id="element-222">
                <feature.icon className="text-[#c9a96e] mb-4" size={32} data-id="element-223" />
                <h3 className="text-xl font-serif font-bold text-white mb-1" data-id="element-224">
                  {feature.title}
                </h3>
                <p className="text-xs text-gray-400 uppercase tracking-wider mb-3" data-id="element-225">
                  {feature.subtitle}
                </p>
                <p className="text-gray-300 text-sm leading-relaxed" data-id="element-226">
                  {feature.desc}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}